export const IS_MOBILE =
  typeof navigator != 'undefined'
    ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    : false;

export const QCHAT_DEFAULT_TEXT_COLOR = '#F6F8FA';
export const QCHAT_MAIN_TEXT_COLOR = '#333333';

export const SENTRY_EVENT_LIMIT_BY_SESSION = 100;
